import "../category.scss"; //import styles from "./Category.module.scss" if you want to use module
import "react-input-range/lib/css/index.css";

import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import InputRange from "react-input-range";

import { Input, LocalizedLink } from "../../components/primitives";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services";

function handleCheckbox(position: any, size: any, setSize: (value: any) => void) {
    let sizeArray = [...size];
    let newSize = sizeArray[position];
    newSize = !newSize;
    sizeArray[position] = newSize;

    setSize(sizeArray);
}
function handleCertifiedCheckbox(
    position: any,
    certified: any,
    setCertified: (value: any) => void
) {
    let certifiedArr = [...certified];
    let newCertified = certifiedArr[position];
    newCertified = !newCertified;
    certifiedArr[position] = newCertified;
    setCertified(certifiedArr);
}

type CategoryFiltersProps = {
    category: any;
    families: any;
    setArea: (value: any) => void;
    setPower: (value: any) => void;
    setPrice: (value: any) => void;
    setSize: (value: any) => void;
    setMadeIn: (value: any) => void;
    madeIn: any;
    size: any;
    currentLocale: any;
    certified: any;
    setCertified: (value: any) => void;
};

export default function CategoryFilters(props: CategoryFiltersProps) {
    const {
        category,
        setArea,
        setPower,
        setPrice,
        setSize,
        size,
        madeIn,
        setMadeIn,
        currentLocale,
        certified,
        setCertified,
    } = props;

    const { t } = useTranslation("templatePages");
    const [areaTemp, setAreaTemp] = useState<any>({ min: 0, max: 2700 });
    const [powerTemp, setPowerTemp] = useState<any>({ min: 0, max: 120000 });
    const [priceTemp, setPriceTemp] = useState<any>({ min: 0, max: 3000 });

    const servicesContext = useContext(ServicesContext);
    const storeService = servicesContext.magento.storeService;

    const mockCurrency = currentLocale.includes("CAD") ? "CAD" : "USD";

    return (
        <div className="filters">
            <div className="made-in">
                <h4 className="filterName">{t("made-in")}</h4>
                <div>
                    <label htmlFor="canada">
                        <Input
                            id="canada"
                            type="checkbox"
                            name="madeIn"
                            checked={madeIn[0]}
                            onChange={() => handleCheckbox(0, madeIn, setMadeIn)}
                        />
                        {t("canada")}
                    </label>
                </div>
                <div>
                    <label htmlFor="usa">
                        <Input
                            id="usa"
                            type="checkbox"
                            name="madeIn"
                            checked={madeIn[1]}
                            onChange={() => handleCheckbox(1, madeIn, setMadeIn)}
                        />
                        {t("usa")}
                    </label>
                </div>
            </div>

            <div className="size">
                <h4 className="filterName">{t("size")}</h4>
                <div>
                    <label htmlFor="small">
                        <Input
                            id="small"
                            type="checkbox"
                            name="size"
                            checked={size[0]}
                            onChange={() => handleCheckbox(0, size, setSize)}
                        />
                        {t("small")}
                    </label>
                </div>
                <div>
                    <label htmlFor="medium">
                        <Input
                            id="medium"
                            type="checkbox"
                            name="size"
                            checked={size[1]}
                            onChange={() => handleCheckbox(1, size, setSize)}
                        />
                        {t("medium")}
                    </label>
                </div>
                <div>
                    <label htmlFor="large">
                        <Input
                            id="large"
                            type="checkbox"
                            name="size"
                            checked={size[2]}
                            onChange={() => handleCheckbox(2, size, setSize)}
                        />
                        {t("large")}
                    </label>
                </div>
                <div>
                    <label htmlFor="xlarge">
                        <Input
                            id="xlarge"
                            type="checkbox"
                            name="size"
                            checked={size[3]}
                            onChange={() => handleCheckbox(3, size, setSize)}
                        />
                        {t("xlarge")}
                    </label>
                </div>
            </div>

            <div className="dataSliders">
                <h4 className="filterName">{t("area-filter")}</h4>

                <InputRange
                    formatLabel={(value) => `${value} ${t("square-foot")}`}
                    step={100}
                    minValue={0}
                    maxValue={2700}
                    value={areaTemp}
                    onChange={(value) => setAreaTemp(value)}
                    onChangeComplete={() => setArea(areaTemp)}
                />
            </div>

            <div className="dataSliders">
                <h4 className="filterName">{t("power-filter")}</h4>
                <InputRange
                    formatLabel={(value) => `${value} ${t("btu-per-hour")}`}
                    step={1000}
                    minValue={0}
                    maxValue={120000}
                    value={powerTemp}
                    onChange={(value) => setPowerTemp(value)}
                    onChangeComplete={() => setPower(powerTemp)}
                />
            </div>

            <div className="dataSliders">
                <h4 className="filterName">{t("price-filter")}</h4>
                <InputRange
                    formatLabel={(value) =>
                        storeService.formatLocalePrice({ value: value, currency: mockCurrency })
                    }
                    step={100}
                    minValue={0}
                    maxValue={3000}
                    value={priceTemp}
                    onChange={(value) => setPriceTemp(value)}
                    onChangeComplete={() => setPrice(priceTemp)}
                />
            </div>

            <div className="size">
                <h4 className="filterName">{t("certified-installation")}</h4>
                <div>
                    <label htmlFor="small">
                        <Input
                            id="small"
                            type="checkbox"
                            name="size"
                            checked={certified[0]}
                            onChange={() => handleCertifiedCheckbox(0, certified, setCertified)}
                        />
                        {t("maison-mob")}
                    </label>
                </div>
                <div>
                    <label htmlFor="medium">
                        <Input
                            id="medium"
                            type="checkbox"
                            name="size"
                            checked={certified[1]}
                            onChange={() => handleCertifiedCheckbox(1, certified, setCertified)}
                        />
                        {t("alcove")}
                    </label>
                </div>
                <div>
                    <label htmlFor="large">
                        <Input
                            id="large"
                            type="checkbox"
                            name="size"
                            checked={certified[2]}
                            onChange={() => handleCertifiedCheckbox(2, certified, setCertified)}
                        />
                        {t("epa")}
                    </label>
                </div>
            </div>
        </div>
    );
}
